import dayjs from "dayjs";

export const configuration = {
    quote: {
        ordinaryAge:process.env.QUOTE_ORDINARY_AGE,
        ordinary:process.env.QUOTE_ORDINARY_VALUE,
        default:'0',
        pressSustain: 10
    },
    none:'NONE',
    empty:'',
    noIndex:-1,

    yn: {
        yes:'STATUS_YES',
        no:'STATUS_NO'
    },
    
    motive: {
        work: 'MOTIVO-LAVORO',
        study: 'MOTIVO-STUDIO',
        town: 'MOTIVO-RESIDENZA'
    },
    gender: {
        male: 'M',
        female: 'F',
        noAnswer: 'N'
    },
    payments: {
        paypal: 'PAYPAL',
        credictCard: 'CCARD',
        bankWire: 'BANK'
    },
    maxFileSize:'7',
    phoneCode:'+39',
    requiredChar:' *',
    
    //previousYear:new Date().getFullYear()-1,
    //displayYear:new Date().getFullYear(),
    previousYear: dayjs().year()-1,
    displayYear: dayjs().year(),

    emailPattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    minDate:'1970-01-01',
    currentLocaleDate: document.documentElement.lang, // Intl.DateTimeFormat().resolvedOptions().locale,
    currentAppLocale: document.documentElement.lang,
    acceptedFileFormats:'.png, .jpg, .jpeg, .pdf, .doc, .docx',
    currentLocaleDateOptions: {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    }
    
    , moment: {
        localeDateString: 'DD/MM/YYYY'
        , localeDateTimeString: 'DD/MM/YYYY H:mm:ss'
        , formControlDateString: 'YYYY-MM-DD'
    }

    , defaultLinkTimeout: 150
    , floatRegExp: new RegExp('^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$')
    , acceptedEventExportFileFormats:'.json'
    
};

export const app = {
    name: 'EuropaVerdi Tesseramento' //process.env.APP_NAME
    , alias: process.env.APP_ALIAS
    , logo: '/storage/assets/logo.png'
    , backgroundImage: 'images/background.png'
    , backgroundOpacityLayer: 'rgba(0, 0, 0, 0.6)'
    , title: process.env.APP_NAME
    , mainRowPadding: 30
    , secret_key: process.env.APP_KEY
    , inactivityTimeOut: (8 * 60 * 60 * 1000)               // 08 h
    , inactivityCountdown: (15)                             // 15 s
    , coockieTimeOut: (8 * 60 * 60 * 1000)                  // 08 h

    , version: 'β - 0.1.20250812'
    , headerCommandIconSize: 36
    , tableCommandIconSize: 18

    , homeIconSize: 75
    , headerIconSize: 30

    , modalHeaderIconSize: 90
}

/*
export enum sliceStateStatus {
    idle = 'idle',
    pending = 'pending',
    fulfilled = 'fulfilled',
    rejected = 'rejected'
}
*/

export enum snackbarVariant {
    error = 'error',
    info = 'info',
    success = 'success',
    warning = 'warning'
}

/*
export enum systemRoles {
    admin = 'ROLE_ADMIN',
    user = 'ROLE_USER',
    editor = 'ROLE_EDITOR',
    hero = 'SUPER_HERO'
}
*/

export const systemStatus = {
    active: 'STATUS_ACTIVE',
    inactive: 'STATUS_INACTIVE',
    open: 'STATUS_OPEN',
    closed: 'STATUS_CLOSED',
    deleted: 'STATUS_DELETED',
    added: 'STATUS_ADDED',
    edited: 'STATUS_EDITED'
}

export enum appSections {
    accounts = "SEC_ACCOUNTS",
    users = "SEC_USERS"
}


export enum settingsSections {
    users = "users",
    accounts = "accounts",
}

export enum spinnerAnimation { border = 'border',  grow = 'grow' }